import ModeShippingWizard from "./modeShippingWizard.js"
import RelayShippingWizard from "./relayShippingWizard.js"
import HomeShippingWizard from "./homeShippingWizard.js"
import StoreShippingWizard from "./storeShippingWizard.js"
import EventManager from "../eventManager.js"
import Config from "../config.js"
import MessageBoxManager from '../messageBox/messageBoxManager.js'
import StringUtils from '../utils/string.js'

export default class SenderShippingWizard extends EventManager {

  constructor(senderId, $container, options) {

    super()

    this.settings = $.extend({}, {
      ressources: null,
      animationQueue: null
    }, options)

    this.$container = $container
    this.$content = $container.find('> .content')

    this.$content.addClass('edition')

    this.$packageContentHandler = $('<span/>', { class: 'package-content' })
      .appendTo(this.$container.children('h2'))

    this.$container.children('h2.sender')
      .click(this.showProducts.bind(this))

    this.$parcelGlimpseContainer = $('<span/>', { class: 'parcel-glimpse-container' })
      .appendTo(this.$packageContentHandler)

    this.$actionsBar = $('<div/>', { class: 'actions-bar' })
      .prependTo(this.$content) // Components must pe prepended in order to let loader overlay be the last child

    this.$validationButton = $('<button/>', { class: 'button validate disabled' })
      .html('Valider')
      .click(this.on.bind(this, 'validation_request'))
      .appendTo(this.$actionsBar)

    this.$editionButton = $('<button/>', { class: 'button edit' })
      .html('Modifier la livraison')
      .click(() => {
        $('html, body').animate(
          { scrollTop: this.$container.offset().top - Config.headerHeightMobile },
          'slow'
        )
        this.showOffers()
      })
      .appendTo(this.$actionsBar)

    this.$modesContainer = $('<div/>', { class: 'offers' })
      .prependTo(this.$content) // Components must pe prepended in order to let loader overlay be the last child

    this.$summaryContainer = $('<div/>', { class: 'summary' })
      .hide()
      .prependTo(this.$content)
      .append('<div/>')

    this.$infoContainer = $('<div/>', { class: 'infos' })
      .prependTo(this.$content)

    this.messageBoxManager = new MessageBoxManager(this.$infoContainer)

    this.senderId = senderId

    this.senderOffers = null

    this.currentAddress = null

    this.modeShippingWizards = []

    this.listeners = []

    this.isValidated = false

    this.addListener('validation_request', () => {
      if (this.hasErrors()) {
        popup.info(this.getErrors()[0].message, { type: 'error' });
      } else if (this.currentSelection != undefined && !this.$validationButton.hasClass('disabled')) {
        this.saveShippingOffer(this.currentSelection)
          .then((response) => {
            if (response.result == true) {
              this.isValidated = true
              this.showSummary()
              this.on('validation_succeed')
            } else {
              popup.info(response.message == undefined
                  ? "Une erreur est survenue lors de la sélection de la livraison."
                  : response.message,
                { type: 'error' }
              );
            }
          }).fail((response) => {
          popup.info("Une erreur est survenue lors de la sélection de la livraison.",
            { type: 'error' }
          )
        })
      }
    })

  }

  configure(options) {
    this.settings = $.extend({}, this.settings, options)
  }

  showProducts(event) {
    if (this.senderOffers !== null) {
      popup.info(`
        <table>
          <thead>
            <tr>
              <th>Libellé</th>
              <th>Quantité</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                  ${this.senderOffers.products.map(product => product.libelle + '</td><td>X' + product.quantity).join('</td></tr><tr><td>')}
              </td>
            </tr>
          </tbody>
        </table>
      `, { title: $(event.delegateTarget).prev().html() })
    }
  }

  onSelectionChanged() {

    let [modeWizard, offer, $element, ...args] = [...arguments]

    // reset selection of other wizards
    let selected_mode = null
    for (let mode in this.modeShippingWizards) {
      if (this.modeShippingWizards[mode] !== modeWizard) {
        this.modeShippingWizards[mode].resetSelection()
      } else {
        selected_mode = mode
      }
    }

    this.isValidated = false

    if (selected_mode == null) {
      popup.info("Une erreur est survenue lors de la sélection de la livraison.", { type: 'error' })
    }

    this.$validationButton.removeClass('disabled').addClass('shake')

    this.currentSelection = {
      shipping_mode: selected_mode,
      id_merchant: this.senderId,
      shipping_provider: offer.type
    }

    if (selected_mode == "home" ||
      (selected_mode == "store" && $element.find('.right').length === 0) ||
      (selected_mode == "relay" && $element.find('.right').length === 0)) {

      this.$summaryContainer.children()
        .empty()
        .append(
          $('<div/>', { class: 'choice' }).append($element.html())
        )
    } else if (selected_mode == "relay") {
      this.$summaryContainer.children().html(`
          <div class="choice">
            ${$element.find('.right').html()}
            <div class="address">
              ${$element.html()}
            </div>
          </div>
        `)
      this.$summaryContainer.find('.address .right, .address .checkbox').remove()
      this.$summaryContainer.find('ul.horaires').hide()
      this.$summaryContainer.find('p.horaires').html('Voir les horaires').addClass('link').click(() => {
        if (this.$summaryContainer.find('ul.horaires').is(':visible')) {
          this.$summaryContainer.find('ul.horaires').slideUp()
        } else {
          this.$summaryContainer.find('ul.horaires').slideDown()
        }
      })
    } else {
      this.$summaryContainer.children().html($element.html())
    }

    this.$summaryContainer.children().attr('class', selected_mode)

    if (offer.id != undefined) {
      this.currentSelection.shipping_offer_id = offer.id
    } else if (selected_mode == "relay") {
      this.currentSelection.shipping_offer_id = offer.id_retrait
      this.currentSelection.shipping_offer = offer.data
    }

    //    if (modeWizard.addressChanged === false) {
    //      this.$validationShip = this.on('validation_request')
    //    }
    this.setButtonCost(this.senderOffers.shippingModes.drop.extraCost + offer.cost.total)

    // call listeners
    this.on('select', this, ...arguments)

    return this

  }

  onSelectionReseted(mode) {
    if (this.currentSelection && (this.currentSelection.shipping_mode == mode || mode == undefined)) {
      this.currentSelection = null
      this.on('unselect', this, ...arguments)
      this.setButtonCost()
      this.$validationButton.addClass('disabled')
    }
  }

  setButtonCost(cost) {
    let $cost = this.$validationButton.find('span.cost')

    if (cost === undefined) {
      $cost.remove()
    } else {
      if ($cost.length == 0) {
        $cost = $('<span/>', { class: 'cost' }).appendTo(this.$validationButton)
      }
      $cost.html(`(${cost > 0 ? StringUtils.toLocaleString(cost, {style: 'currency', currency: 'EUR'}) : 'Gratuit'})`) // Gratuit du bouton valider
    }
  }

  showSummary() {
    this.$content.addClass('summary')
    this.$content.removeClass('edition')
    this.settings.animationQueue.add(this.$modesContainer, $.fn.slideUp)
    this.$summaryContainer.slideDown()
  }

  showOffers() {
    this.$content.addClass('edition')
    this.$content.removeClass('summary')
    this.$summaryContainer.slideUp()
    this.settings.animationQueue.add(this.$modesContainer, $.fn.slideDown)
  }

  invalidate() {
    for (let wizard in this.modeShippingWizards) {
      this.modeShippingWizards[wizard].invalidate()
    }
  }

  updateAddress(address) {

    this.currentAddress = address

    for (let wizard in this.modeShippingWizards) {
      this.modeShippingWizards[wizard].updateAddress(address)
    }

    this.$validationButton.find('span.cost').remove()
    this.$validationButton.addClass('disabled')
    this.isValidated = false
  }

  addModeContainer(mode, title, options) {

    let settings = $.extend({}, {
      selected: false
    }, options)

    let $title = $('<h3/>', { 'data-mode': mode }).html($('<span class="checkbox"></span>'))
    $title.append(title)
    this.$modesContainer.append($title)
    $title.click(this.selectMode.bind(this, mode))

    let $modeContentContainer = $('<div/>', { class: 'mode-content', 'data-mode': mode }).appendTo(
      this.$modesContainer
    );

    if (settings.selected) {
      $title.addClass('selected')
    } else {
      $modeContentContainer.hide()
    }

    return $modeContentContainer

  }

  selectMode(mode, event) {
    if (!$(event.delegateTarget).hasClass('selected')) {
      this.$modesContainer
        .find('> h3.selected')
        .removeClass('selected')
        .next('div.mode-content')
        .slideUp({
          complete: () =>
            app.getViewportManagerInstance().viewportMode === app.getViewportManagerInstance().MOBILE_VIEWPORT
              ? $('html, body').animate({ scrollTop: this.getModeContainer(mode).prev('h3').offset().top - Config.headerHeightMobile }, 'slow')
              : null
        })
      this.getModeContainer(mode).prev('h3').addClass('selected')
      this.getModeContainer(mode).slideDown({ start: () => this.invalidate() })
      this.onSelectionReseted()
      this.modeShippingWizards[mode].resetSelection()
    }
  }

  getModeContainer(mode) {
    return this.$modesContainer.find('> div[data-mode=' + mode + ']')
  }

  removeModeContainer(mode) {
    this.getModeContainer(mode).prev('h3').remove()
    this.getModeContainer(mode).remove()
  }

  getErrors() {

    let generalErrors = this.senderOffers.infos.filter(info => info.level == 'error')

    for (let infoType in this.senderOffers.product_infos) {

      let info = this.senderOffers.product_infos[infoType]

      if (info.level == 'error') {
        if (info.list.length > 0) {

          let list = ''

          for (let product of info.list) {
            list += `<li>${product}</li>`
          }

          let message = `
              <p>${info.message !== null ? info.message : ''}</p>
              <ul>${list}</ul>
            `

          if (infoType == 'dropShipping') {
            // Display the extra cost
            let extraCostLabel = this.senderOffers.shippingModes.drop.extraCost > 0
              ? `+ ${this.senderOffers.shippingModes.drop.extraCost.toFixed(2)} €`
              : 'Gratuit'

            message += `<p class="cost">${extraCostLabel}</p>`
          }

          generalErrors.push({ message: message, level: 'error' })

        }
      }
    }

    return generalErrors
  }

  hasErrors() {
    return this.getErrors().length > 0
  }

  update(senderOffers, options) {

    this.senderOffers = senderOffers

    let settings = $.extend({}, {
      loader: null
    }, options)

    // Let's go for this merchant
    this.$parcelGlimpseContainer.empty()
    for (const product of senderOffers.products) {
      if (product.image) {
        this.$parcelGlimpseContainer.append($('<img/>', {
          src: product.image,
          title: `${product.libelle} (x${product.quantity})`
        }))
      }
    }

    this.showOffers()
    this.$infoContainer.empty()

    if (options.birthList.enabled) {
      this.currentAddress = options.birthList.address
    }

    // Remove Wizards that should be
    let newModes = [];
    for (let mode in senderOffers.shippingModes) {
      if (senderOffers.shippingModes[mode].offers.length) {
        newModes.push(mode)
      }
    }

    let oldModes = Object.keys(this.modeShippingWizards)
    let vanishedModes = oldModes.filter(i => newModes.indexOf(i) < 0)

    for (let vanishedMode of vanishedModes) {
      this.modeShippingWizards[vanishedMode].remove()
      delete this.modeShippingWizards[vanishedMode]
      this.removeModeContainer(vanishedMode)
    }

    if (newModes.length == 0) {
      // There is no offer for the sender, there is a problem...
      if (!options.birthList.enabled && this.currentAddress.length === 0) {
        this.messageBoxManager.notify(
          'Vous devez d\'abord renseigner et/ou sélectionner votre adresse de livraison !',
          { type: 'info' }
        )

      } else if (!options.birthList.enabled && this.currentAddress.country === 'BEL') {
        this.messageBoxManager.notify(
          'Nous sommes désolés, nous ne sommes plus en mesure de livrer en Belgique. Toutefois, si vous habitez près des frontières, vous pouvez vous faire livrer en point de retrait en France.',
          { type: 'error' }
        )
      } else {
        this.messageBoxManager.notify(
          'Aucun mode de transport n\'a été trouvé... <a href="nous-contacter,bebe,contact,contact_mail,3.couche-lavable.html" target="blank">veuillez contacter notre service client ou réessayer plus tard</a>',
          { type: 'error' }
        )
      }
    }

    // Display general messages
    for (let info of senderOffers.infos) {

      this.messageBoxManager.notify(`<p>${info.message}</p>`, { type: info.level })

    }

    // product infos
    for (let infoType in senderOffers.product_infos) {

      let info = senderOffers.product_infos[infoType]
      if (info.list.length > 0) {

        let list = ''

        for (let product of info.list) {
          list += `<li>${product}</li>`
        }

        let message = `
            <p>${info.message !== null ? info.message : ''}</p>
            <ul>${list}</ul>
          `

        if (infoType == 'dropShipping') {
          // Display the extra cost
          let extraCostLabel = senderOffers.shippingModes.drop.extraCost > 0
            ? `+ ${senderOffers.shippingModes.drop.extraCost.toFixed(2)} €`
            : 'Gratuit'

          message += `<p class="cost">${extraCostLabel}</p>`
        }

        this.messageBoxManager.notify(message, { type: info.level })

      }

    }

    let preselectedMode = null
    let modesWithOffers = Object.keys(senderOffers.shippingModes).filter(mode => senderOffers.shippingModes[mode].offers.length > 0)
    if (oldModes.length == 0) {
      if ('relay' in modesWithOffers) {
        preselectedMode = 'relay'
      } else if (modesWithOffers.length) {
        preselectedMode = modesWithOffers[0]
      }
    }

    for (let mode in senderOffers.shippingModes) {

      if (mode == 'drop' || mode == 'email') {
        continue;
      }

      let senderMode = senderOffers.shippingModes[mode]

      // What's the proposals for this mode ?
      if (senderMode.offers.length) {

        settings.providers = {}

        for (let offer of senderMode.offers) {
          settings.providers[offer.type] = {
            label: offer.provider,
            deliverDateLabel: offer.deliverDateLabel
          }
        }

        let $modeContainer = this.getModeContainer(mode)

        if ($modeContainer.length == 0) {
          $modeContainer = this.addModeContainer(mode, senderMode.name, { selected: mode == preselectedMode })
        }

        let wizardClass = ModeShippingWizard
        if (mode == 'relay') {
          wizardClass = RelayShippingWizard
        } else if (mode == 'home') {
          wizardClass = HomeShippingWizard
        } else if (mode == 'store') {
          wizardClass = StoreShippingWizard
        }

        if (!(mode in this.modeShippingWizards)) {
          this.modeShippingWizards[mode] = new wizardClass($modeContainer, {
            ressources: this.settings.ressources,
            animationQueue: this.settings.animationQueue
          })
          this.modeShippingWizards[mode].updateAddress(this.currentAddress)
          this.modeShippingWizards[mode].addListener('select', this.onSelectionChanged.bind(this))
          this.modeShippingWizards[mode].addListener('unselect', this.onSelectionReseted.bind(this, mode))
        }

        let extraSettings = {}
        if (options.birthList.enabled && mode in options.birthList) {
          extraSettings.forceOffer = options.birthList[mode]
        }

        this.modeShippingWizards[mode].update(senderMode, $.extend({}, settings, extraSettings))

      }

    }

    // Valid if only drop and/or email shipping
    let nonShippingModes = ['drop', 'email']
    let virtualShippingModes = newModes.filter(i => nonShippingModes.indexOf(i) >= 0)
    let realShippingModes = newModes.filter(i => nonShippingModes.indexOf(i) < 0)

    if (realShippingModes.length == 0 && virtualShippingModes.length > 0) {
      let validationMode = virtualShippingModes.indexOf('drop') >= 0 ? 'drop' : 'email'
      this.currentSelection = {
        shipping_mode: validationMode,
        id_merchant: this.senderId,
        shipping_provider: validationMode
      }
      this.setButtonCost(senderOffers.shippingModes.drop.extraCost.toFixed(2))
      this.$validationButton.removeClass('disabled')
      //      this.$validationShip = this.on('validation_request')
    } else if (realShippingModes.length == 1) {
      if (realShippingModes[0] == 'store'
        || realShippingModes[0] == 'home' && senderOffers.shippingModes.home.offers.length == 1) {
        this.modeShippingWizards[realShippingModes[0]].$list.children('li').click()
      }
    }
  }

  saveShippingOffer(selection) {
    return $.post("core/ajax/ajax_panier.php", $.extend({}, {
      action: "set_livraison",
      _format: 'json',
    }, selection))
  }
}